import React from 'react';
import { Box, Alert } from '@mui/material';
import InspectionCard from './InspectionCard';
import { CompletedViewProps, InspectionStatus } from './types';

/**
 * CompletedView - Component for displaying completed inspections
 */
const CompletedView: React.FC<CompletedViewProps> = ({ 
  filteredInspections, 
  handleViewDetails, 
  handleActionMenuOpen,
  selectedInspection,
  setSelectedInspection,
}) => {
  // Empty function for the required props in InspectionCard
  const noopFunction = () => {};
  const noopUpdateStatus = (_id: string, _status: InspectionStatus) => {
    // eslint-disable-next-line no-console
    console.log("_id", _id, _status)
  };

  return (
    <Box>
      {filteredInspections.length === 0 && (
        <Alert severity="info" sx={{ mt: 2 }}>
          No completed inspections found.
        </Alert>
      )}
      
      {filteredInspections.map(inspection => (
        <InspectionCard
          key={inspection.id}
          inspection={inspection}
          handleOpenCompletionDialog={noopFunction} // No need to complete already completed inspections
          handleViewDetails={handleViewDetails}
          handleActionMenuOpen={handleActionMenuOpen}
          selectedInspection={selectedInspection}
          setSelectedInspection={setSelectedInspection}
          handleUpdateStatus={noopUpdateStatus} // No status updates needed in completed view
        />
      ))}
    </Box>
  );
};

export default CompletedView;